import React, { useContext } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { THEME_SETTINGS } from "@theme-settings";
import { getRedirectOriginUrl } from "@utils/specific/capacitor/helpers";
import { BetDetailsModalStoreContext } from "@state/context/my-bets/BetDetailsModalStoreContext";
import { useRootAppStore } from "@hooks";

import { useFixBody } from "@state/hooks/shared";
import { Button } from "@components/buttons";

export const BetDetailsShareBetSlip = observer(
	function BetDetailsShareBetSlip() {
		const store = useContext(BetDetailsModalStoreContext);
		const rootStore = useRootAppStore();

		const { t } = useTranslation("mybets");
		useFixBody(false, store?.shareBetSlipStore.isActive, "reuse-form");

		if (!THEME_SETTINGS.features.isBetSlipShareEnabled) {
			return null;
		}

		if (store == null) {
			return null;
		}

		const sharedBetSlip = store.shareBetSlipStore.activeSharedBetSlip;

		if (!store.isShareActive || !sharedBetSlip) {
			return null;
		}

		return (
			<div className="popup__footer popup__footer--bordered">
				<div id="reuse-form" className="popup__header u-padd--reset">
					{t("SHARE.SHARE_TITLE")}
				</div>

				<div className="popup--share__row">
					<div className="popup--share__item">
						<a
							href={`https://api.whatsapp.com/send?text=${getRedirectOriginUrl(
								`/bet-slip-shared/${sharedBetSlip.betSlipNumber}`
							)}`}
							data-action="share/whatsapp/share"
							target="_blank"
							className="popup--share__btn--whatsapp btn btn--round btn--round--base btn--icon"
							onClick={() => {
								store.shareBetSlipStore.insertSharedBetSlip();
							}}
						>
							<i className="u-icon u-icon--med u-icon--whatsapp u-color--core--snow" />
						</a>
						<span className="popup--share__label">WhatsApp</span>
					</div>
					<div className="popup--share__item">
						<a
							href={`viber://forward?text=${getRedirectOriginUrl(
								`/bet-slip-shared/${sharedBetSlip.betSlipNumber}`
							)}`}
							target="_blank"
							className="popup--share__btn--viber btn btn--round btn--round--base btn--icon"
							onClick={() => {
								store.shareBetSlipStore.insertSharedBetSlip();
							}}
						>
							<i className="u-icon u-icon--med u-icon--viber u-color--core--snow" />
						</a>
						<span className="popup--share__label">Viber</span>
					</div>
					<div className="popup--share__item">
						<a
							className="popup--share__btn--email btn btn--round btn--round--base btn--icon"
							href={`mailto:?subject=Bet%20slip&body=${getRedirectOriginUrl(
								`/bet-slip-shared/${sharedBetSlip.betSlipNumber}`
							)}`}
							title="Share by Email"
							onClick={() => {
								store.shareBetSlipStore.insertSharedBetSlip();
							}}
						>
							<i className="u-icon u-icon--med u-icon--email--str u-color--core--snow" />
						</a>
						<span className="popup--share__label">Email</span>
					</div>
					{WEBPACK_IS_CHAT_AVAILABLE && (
						<div className="popup--share__item">
							<button
								className="popup--share__btn--chat btn btn--round btn--round--base btn--icon"
								title="Share to Chat"
								onClick={() => {
									rootStore.chatViewStore.openBetSlipMessagePreview(
										sharedBetSlip
									);
									store.shareBetSlipStore.onBetDetailsShareClose();
									store.onShareClose();
									store.closeModal();
								}}
							>
								<i className="u-icon u-icon--med u-icon--sml--responsive u-icon--chat--str u-color--core--snow"></i>
							</button>
							<span className="popup--share__label">Chat</span>
						</div>
					)}
				</div>

				<div className="popup--share__copy">
					<i className="u-icon u-icon--base u-icon--hyperlink" />
					<span className="popup--share__copy__label">
						{getRedirectOriginUrl(
							`/bet-slip-shared/${sharedBetSlip.betSlipNumber}`
						)}
					</span>
					<button
						className="popup--share__copy__btn btn btn--sml btn--accent"
						type="button"
						onClick={() => {
							store.shareBetSlipStore.copyLink();
						}}
					>
						{t("SHARE.COPY_LINK")}
					</button>
				</div>
				<Button
					btnText={t("mybets:ITEM.BET_SLIP_COMBINATIONS.CLOSE")}
					onClick={store.onShareClose}
					className="btn--base btn--block btn--primary--inverted drawer__action--primary"
				/>
			</div>
		);
	}
);
